  <template>
    <v-app>
      <Pos_monitor/>
    </v-app>
  </template>
  
  <script>
  import Pos_monitor from "@/components/adminArin/pos_system/pos/Pos_monitor";
  export default {
    name: "PosMonitor",
    components: {
        Pos_monitor
    }
  }
  </script>

<style scoped>

</style>
  